module.exports = {"Table":{"filterTitle":"Filter Menu","emptyText":"No Data"},"Popconfirm":{"okText":"OK","cancelText":"Cancel"},"Pagination":{"prev_page":"Previous Page","next_page":"Next Page"},"Select":{"notFoundContent":"Not Found"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/ui.json
// module id = 50
// module chunks = 0